import { render } from "./IntegrationEdit.vue?vue&type=template&id=1368ffeb&ts=true"
import script from "./IntegrationEdit.vue?vue&type=script&lang=ts"
export * from "./IntegrationEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__